import React, {useMemo} from "react";
import {FileSearchOutlined} from "@ant-design/icons";
import {Button, Modal, Tag} from "antd";
import {useState} from "react";
import {DetailModalContainer, DetailTitle} from "./PoolPaymentContractDetail.styles";
import {FeeTypesContainer} from "components/company/subCompanyDetail/subCompanyPaymentContracts/subCompanyPaymentContractForm/SubCompanyPaymentContractForm.styles";
import {FeeTypeCard} from "components/company/subCompanyDetail/subCompanyPaymentContracts/subCompanyPaymentContractForm/components/FeeTypeCard";
import {useStore} from "hooks/useStore";

// Pool için sadece PAKET ve KM tipleri kullanılabilir
const POOL_FEE_TYPES = [
    {value: "PAKET", name: "Paket"},
    {value: "KM", name: "Mesafe"}
];

export const PoolPaymentContractDetail = ({poolPaymentContract = {}}) => {
    const [isVisible, setVisible] = useState(false);
    const stores = useStore();

    const userIsCustomer = !stores.meStore.checkRole("notVisibleForCompanyUser");

    // feeItems'ı feeType'a göre grupla
    const organizedFeeItems = useMemo(() => {
        const feeItems = poolPaymentContract?.feeItems || [];
        const organized = {};

        feeItems.forEach(item => {
            if (!organized[item.feeType]) {
                organized[item.feeType] = {default: null, custom: []};
            }
            if (item.options?.isCustomTimed) {
                organized[item.feeType].custom.push(item);
            } else {
                organized[item.feeType].default = item;
            }
        });

        return organized;
    }, [poolPaymentContract?.feeItems]);

    // Noop fonksiyonlar - read-only mod için
    const noop = () => {};

    return (
        <>
            <Button onClick={() => setVisible(true)} icon={<FileSearchOutlined />} />
            <Modal
                zIndex={1000}
                id="poolPaymentContractDetailModal"
                visible={isVisible}
                title={
                    <DetailTitle>
                        Sözleşme Detayları{" "}
                        {poolPaymentContract?.contractId ? (
                            <Tag style={{fontWeight: "normal"}}>
                                {poolPaymentContract?.contractId}
                            </Tag>
                        ) : (
                            ""
                        )}
                    </DetailTitle>
                }
                onCancel={() => setVisible(false)}
                cancelText="Kapat"
                okButtonProps={{style: {display: "none"}}}
                width={1400}
                centered
                bodyStyle={{overflowY: "auto", maxHeight: "70vh"}}
            >
                <DetailModalContainer>
                    <FeeTypesContainer>
                        {POOL_FEE_TYPES.filter(feeType => organizedFeeItems[feeType.value]).map(
                            feeType => {
                                return (
                                    <FeeTypeCard
                                        key={feeType.value}
                                        feeType={feeType.value}
                                        feeTypeName={feeType.name}
                                        defaultFeeItem={organizedFeeItems[feeType.value]?.default}
                                        customFeeItems={
                                            organizedFeeItems[feeType.value]?.custom || []
                                        }
                                        disabled={true}
                                        onDefaultChange={noop}
                                        onCustomItemChange={noop}
                                        onAddCustomItem={noop}
                                        onRemoveCustomItem={noop}
                                        onRemoveFeeType={null}
                                        userIsCustomer={userIsCustomer}
                                        isPool={true}
                                    />
                                );
                            }
                        )}
                    </FeeTypesContainer>
                </DetailModalContainer>
            </Modal>
        </>
    );
};
